import { theme } from '../constants/defaults';

function renderProductInfo(item) {
  const { url, name, vendor, properties, optionWithValue } = item;
  let variationText = '';

  if (optionWithValue) {
    optionWithValue.forEach((nameValue) => {
      if (nameValue.value !== 'Default Title') {
        variationText += `<span class="ajaxcart__product-meta">${nameValue.name}: ${nameValue.value}</span>`;
      }
    });
  }

  const propertiesList = [];
  if (properties) {
    Object.keys(properties).forEach((key) => {
      const value = properties[key];

      if (key.substring(0, 1) !== '_' && key !== '') {
        propertiesList.push(`<span class="ajaxcart__product-meta">${key}: ${value}</span>`);
      }
    });
  }

  return `
    <p class="ajaxcart__product-info">
      <a href="${url}" class="ajaxcart__product-name">
        ${name}
      </a>
      ${variationText}
      ${propertiesList.join('')}

      ${theme.settings.cartVendor ? `<span class="ajaxcart__product-meta">${vendor}</span>` : ''}
    </p>
  `;
}

function renderProductQuantity(item) {
  const { key, quantity, id } = item;

  return `
    <label for="${key}-quantity" class="vh">${theme.strings.cart_quantity_label}</label>
    <div class="quantity-select js-quantity-select">
      <button type="button" class="quantity-select__button" data-increment="-1">
        <span aria-hidden="true">-</span>
        <span class="vh">${theme.strings.cart_reduce_quantity}</span>
      </button>
      <input type="number"
        class="input quantity-select__input"
        min="0"
        id="${key}-quantity"
        name="updates[]" value="${quantity}"
        data-key="${key}"
        data-id="${id}"
      />
      <button type="button" class="quantity-select__button" data-increment="1">
        <span aria-hidden="true">+</span>
        <span class="vh">${theme.strings.cart_increase_quantity}</span>
      </button>
    </div>
  `;
}

function renderProductPrice(item) {
  const { discountsApplied, linePrice } = item;

  if (discountsApplied) {
    return `
      <span class="ajaxcart__price">${linePrice}</span>
      <small class="ajaxcart__price-strikethrough">
        <s>${item.originalLinePrice}</s>
      </small>
      ${item.discounts
        .map((discount) => `<small class="ajaxcart__discount">${discount.title}</small>`)
        .join('')}
    `;
  }

  return `
    <span class="ajaxcart__price">${linePrice}</span>
  `;
}

function renderProductImage(item) {
  if (item.image === null) {
    return '';
  }

  const { url, image } = item;
  return `
    <a href="${url}" class="ajaxcart__product-image">
      <img src="${image.url}" alt="${image.alt}">
    </a>
  `;
}

export default (item) => {
  const { key, id } = item;

  return `
    <div class="ajaxcart__product" data-key="${key}">

          ${renderProductImage(item)}

          <div class="ajaxcart__details">
            ${renderProductInfo(item)}
            ${renderProductQuantity(item, id)}
          </div>

          <div class="ajaxcart__price-wrapper">
            ${renderProductPrice(item)}
          </div>

    </div>
  `;
};
